import { useContext } from 'react'

import { ParametrizationCurveStoreContext } from '@provider/Parametrization/CurveStoreProvider'

import { ICurveStoreProvider } from '@base/@types/providers/Parametrization/CurveStoreProvider'
export default function useParametrizationCurveStore(): ICurveStoreProvider {
  const context = useContext(ParametrizationCurveStoreContext)

  return context
}
